import { render, staticRenderFns } from "./FallbackLinks.vue?vue&type=template&id=32bda8ec&scoped=true&"
import script from "./FallbackLinks.vue?vue&type=script&lang=js&"
export * from "./FallbackLinks.vue?vue&type=script&lang=js&"
import style0 from "./FallbackLinks.vue?vue&type=style&index=0&id=32bda8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bda8ec",
  null
  
)

export default component.exports